export const menuData = [
  {
    id: 1,
    mainMenuLabel: "Settings",
    icon: "../../../assets/setting.png",
    selectedIcon: "../../../assets/setting-fill.png",
    mainMenuPermission: "settings",
    root: "settings",
    path: "settings",
    submenu: [
      {
        submenuLabel: "Default",
        mainMenuLabel: "Settings",
        icon: "../../../assets/default.svg",
        path: "settings/core",
        subMenuPermission: "settings.core",
        insiderMenu: [
          {
            insiderMenuPermission: "settings.core.prizone",
            insiderMenuLabel: "Prize Zones",
            insiderMenuPath: "settings/core/prizezones",
          },
        ],
      },
      {
        submenuLabel: "Leagues",
        mainMenuLabel: "Settings",
        icon: "../../../assets/league-black.png",
        path: "settings/leagues",
        subMenuPermission: "dff",
        insiderMenu: [],
      },
    ],
  },
  {
    id: 3,
    mainMenuLabel: "SFF",
    icon: "../../../assets/dff.png",
    selectedIcon: "../../../assets/dff-fill.png",
    mainMenuPermission: "dff",
    root: "settings",
    path: "sff",
    submenu: [
      {
        submenuLabel: "Season",
        mainMenuLabel: "SFF",
        icon: "../../../assets/default.svg",
        path: "sff/seasons-list",
        subMenuPermission: "dff",
        insiderMenu: [],
      },
      {
        submenuLabel: "RFT Match Days",
        mainMenuLabel: "SFF",
        icon: "../../../assets/calendar-1.png",
        path: "sff/rft-matchdays",
        subMenuPermission: "dff",
        insiderMenu: [],
      },
    ],
  },
  {
    id: 4,
    mainMenuLabel: "Accounts",
    icon: "../../../assets/bank.png",
    selectedIcon: "../../../assets/bank-fill.png",
    mainMenuPermission: "dff",
    root: "settings",
    path: "accounts",
    submenu: [
      {
        submenuLabel: "Transactions",
        mainMenuLabel: "Accounts",
        icon: "../../../assets/transaction.svg",
        path: "accounts/user-transactions",
        subMenuPermission: "dff",
        insiderMenu: [],
      },
    ],
  },
  {
    id: 5,
    mainMenuLabel: "Users",
    icon: "../../../assets/user.png",
    selectedIcon: "../../../assets/user-fill.png",
    mainMenuPermission: "dff",
    root: "users",
    path: "users",
    submenu: [
      {
        submenuLabel: "Users",
        mainMenuLabel: "Users",
        icon: "../../../assets/users.svg",
        path: "users/users-list",
        subMenuPermission: "dff",
        insiderMenu: [],
      },
    ],
  },
  {
    id: 6,
    mainMenuLabel: "Assets",
    icon: "../../../assets/assets.png",
    selectedIcon: "../../../assets/assets-fill.png",
    mainMenuPermission: "dff",
    root: "assets",
    path: "assets",
    submenu: [
      {
        submenuLabel: "Players",
        mainMenuLabel: "Assets",
        icon: "../../../assets/player.svg",
        path: "assets/players",
        subMenuPermission: "dff",
        insiderMenu: [],
      },
      {
        submenuLabel: "Clubs",
        mainMenuLabel: "Assets",
        icon: "../../../assets/club-black.png",
        path: "assets/clubs",
        subMenuPermission: "dff",
        insiderMenu: [],
      },
    ],
  },
  {
    id: 7,
    mainMenuLabel: "Notification",
    icon: "../../../assets/notification.png",
    selectedIcon: "../../../assets/notification-fill.png",
    mainMenuPermission: "dff",
    root: "settings",
    path: "notification",
    submenu: [
      {
        submenuLabel: "global-notification",
        mainMenuLabel: "Notification",
        icon: "../../../assets/player.svg",
        path: "notification/GlobalNotification",
        subMenuPermission: "dff",
        insiderMenu: [],
      },
      // {
      //     "submenuLabel": "subMenu2",
      //     "mainMenuLabel": "Notification",
      //     "icon": "../../../assets/club-black.png",
      //     "path": "notification/subMenu2",
      //     "subMenuPermission": "dff",
      //     "insiderMenu": [
      //     ]
      // }
    ],
  },
  {
    id: 8,
    mainMenuLabel: "Subscription",
    icon: "../../../assets/subscription.png",
    selectedIcon: "../../../assets/subscription-fill.png",
    mainMenuPermission: "dff",
    root: "settings",
    path: "subscription",
    submenu: [
      {
        submenuLabel: "RFTC",
        mainMenuLabel: "Subscription",
        icon: "../../../assets/player.svg",
        path: "subscription/RFTC",
        subMenuPermission: "dff",
        insiderMenu: [],
      },
      {
        submenuLabel: "League-Pack",
        mainMenuLabel: "Subscription",
        icon: "../../../assets/player.svg",
        path: "subscription/leaguePack",
        subMenuPermission: "dff",
        insiderMenu: [],
      },
      {
        submenuLabel: "Paid Transfer Pack",
        mainMenuLabel: "Subscription",
        icon: "../../../assets/paid-transfer.png",
        path: "subscription/paid-transfer-overview",
        subMenuPermission: "dff",
        insiderMenu: [],
      },
    ],
  },
  {
    id: 9,
    mainMenuLabel: "Survey",
    icon: "../../../assets/survey.png",
    selectedIcon: "../../../assets/survey-fill.png",
    mainMenuPermission: "dff",
    root: "settings",
    path: "survey",
    submenu: [
      {
        submenuLabel: "Questionnaire",
        mainMenuLabel: "Survey",
        icon: "../../../assets/player.svg",
        path: "survey/questionnaire",
        subMenuPermission: "dff",
        insiderMenu: [],
      },
      {
        submenuLabel: "Question",
        mainMenuLabel: "Survey",
        icon: "../../../assets/player.svg",
        path: "survey/question",
        subMenuPermission: "dff",
        insiderMenu: [],
      },
    ],
  },
  {
    id: 10,
    mainMenuLabel: "Refer & Earn",
    icon: "../../../assets/refer.png",
    selectedIcon: "../../../assets/refer-fill.png",
    mainMenuPermission: "dff",
    root: "settings",
    path: "refer-earn",
    submenu: [
      {
        submenuLabel: "RFT Referral",
        mainMenuLabel: "Refer & Earn",
        icon: "../../../assets/player.svg",
        path: "refer-earn/refer-list",
        subMenuPermission: "dff",
        insiderMenu: [],
      },
    ],
  },
];
